import React from 'react';
import defaultLocales from 'globals/locales/default';
import FsDefaultDialog from 'ui-elements/modals/FsDefaultDialog';
import UpgradeContent from './UpgradeContent';

interface PaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UpgradeModal: React.FC<PaymentMethodModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <FsDefaultDialog
      disableBackdropClick
      disableEscapeKeyDown
      title={defaultLocales.upgrade}
      isOpen={isOpen}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
    >
      <UpgradeContent onClose={onClose} />
    </FsDefaultDialog>
  );
};

export default UpgradeModal;
